import { render, staticRenderFns } from "./auto-message-rule-modal.vue?vue&type=template&id=233fe163&"
import script from "./auto-message-rule-modal.vue?vue&type=script&lang=js&"
export * from "./auto-message-rule-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports